import React, { useId, useState } from 'react';

import { cssMap, cx } from '@atlaskit/css';
import ChevronRightIcon from '@atlaskit/icon/core/chevron-right';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Pressable } from '@atlaskit/primitives/compiled/pressable';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { Text } from '@atlaskit/primitives/compiled/text';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	trigger: {
		backgroundColor: 'transparent',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		width: '100%',
		paddingBlock: token('space.050'),
		paddingInline: token('space.0'),
		textAlign: 'start',
	},
	expanded: {
		cursor: 'default',
	},
});

/** Keeps the heading focused after expansion; closing the popup resets this local state. */
export const ExpandOnlySection = ({
	title,
	children,
	onExpand,
}: {
	children: React.ReactNode;
	onExpand: () => void;
	title: string;
}): React.JSX.Element => {
	const [expanded, setExpanded] = useState(false);
	const contentId = useId();
	return (
		<Stack space={expanded ? 'space.075' : 'space.0'}>
			<Pressable
				xcss={cx(styles.trigger, expanded && styles.expanded)}
				aria-expanded={expanded}
				aria-controls={contentId}
				aria-disabled={expanded}
				onClick={() => {
					if (expanded) return;
					setExpanded(true);
					onExpand();
				}}
			>
				<Text color="color.text" size="small" weight="medium">
					{title}
				</Text>
				{!expanded && <ChevronRightIcon label="" size="small" />}
			</Pressable>
			<Box id={contentId}>{expanded ? children : null}</Box>
		</Stack>
	);
};
